//Paquetes NPM de GYF.
import { LogHelper } from 'com-gyf-webcore-loghelper';
import { Engine1Proxy, RestApiProxy, ConciergeProxy, LogsProxy } from 'com-gyf-webcore-servicehub';

//Exportación de constantes
export const SET_FUNCTIONS_USERS_BY_PROFILE = 'SET_FUNCTIONS_USERS_BY_PROFILE'; 
export const GET_DATA_USERS_BY_PROFILE_START = 'GET_DATA_USERS_BY_PROFILE_START'; 
export const GET_DATA_USERS_BY_PROFILE_SUCCESS = 'GET_DATA_USERS_BY_PROFILE_SUCCESS'; 

export const SEARCH_USER_USERS_BY_PROFILE = 'SEARCH_USER_USERS_BY_PROFILE';
export const SET_ACTIVOS_CHECKBOX_USERS_BY_PROFILE = 'SET_ACTIVOS_CHECKBOX_USERS_BY_PROFILE'; 
export const SET_BLOQUEADOS_CHECKBOX_USERS_BY_PROFILE = 'SET_BLOQUEADOS_CHECKBOX_USERS_BY_PROFILE';   
export const SET_ELIMINADOS_CHECKBOX_USERS_BY_PROFILE = 'SET_ELIMINADOS_CHECKBOX_USERS_BY_PROFILE';   
export const SET_ALL_CHECKBOX_USERS_BY_PROFILE = 'SET_ALL_CHECKBOX_USERS_BY_PROFILE'; 
export const INITIAL_STATE_USUARIOS_PERFIL = "INITIAL_STATE_USUARIOS_PERFIL";

export const FILTER_ORDER_COLUMN_USERS_BY_PROFILE = 'FILTER_ORDER_COLUMN_USERS_BY_PROFILE'; 
export const FILTER_CHECKBOX_USERS_BY_PROFILE = 'FILTER_CHECKBOX_USERS_BY_PROFILE'; 
export const SET_TITLE_USERS_BY_PROFILE = 'SET_TITLE_USERS_BY_PROFILE';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

let _dispatch, _currentScope = null;
let _profileId = null;
let _title2 = null;

/**
 * Obtiene los datos para popular la pantalla.
 * @param {any} state
 * @param {any} currentScope
 */
export function getScreenData(id, currentScope, executionContext) {
    LogHelper.In(getScreenData.name, id, currentScope, executionContext);

    return (dispatch, getState) => {
        const state = getState();
        _dispatch = dispatch;
        _currentScope = currentScope;
        _profileId = id;
        _title2 = null;

        dispatch({ type: GET_DATA_USERS_BY_PROFILE_START, state, currentUser: _currentScope.UserId, currentUserLogin: executionContext.login });

        var currentScopeRequest = {
            "UserId": _currentScope.UserId,
            "ProductCode": _currentScope.ProductCode,
            "ProgramCode": _currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => getFunctionsCallback(data), null, "GETFUNCTIONS", currentScopeRequest, null, "SEGURIDAD");
    }
}

/**
 * Vuelve el estado de la pantalla al inicial de la misma.
 */
export function resetStateUsrPorPerf() {

    LogHelper.In(resetStateUsrPorPerf.name);

    return (dispatch) => {
        dispatch({ type: INITIAL_STATE_USUARIOS_PERFIL });
    }
}

/**
 * Se filtran los usuarios por texto.
 * @param {any} user
 */
export function searchUser(user) {
    LogHelper.In(searchUser.name, user);
    return (dispatch) => {
        dispatch({ type: SEARCH_USER_USERS_BY_PROFILE, user: user });
    }
}

/**
 * Se setea el valor del checkbox de activos.
 * @param {any} activo
 */
export function setActivosCheckbox(activo) {
    LogHelper.In(setActivosCheckbox.name, activo);
    return (dispatch) => {
        dispatch({ type: SET_ACTIVOS_CHECKBOX_USERS_BY_PROFILE, activo: activo });
    }
}

/**
 * Se setea el valor del checkbox de activos.
 * @param {any} bloqueado
 */
export function setBloqueadosCheckbox(bloqueado) {
    LogHelper.In(setBloqueadosCheckbox.name, bloqueado);
    return (dispatch) => {
        dispatch({ type: SET_BLOQUEADOS_CHECKBOX_USERS_BY_PROFILE, bloqueado: bloqueado });
    }
}

/**
 * Se setea el valor del checkbox de activos.
 * @param {any} eliminado
 */
export function setEliminadosCheckbox(eliminado) {
    LogHelper.In(setEliminadosCheckbox.name, eliminado);
    return (dispatch) => {
        dispatch({ type: SET_ELIMINADOS_CHECKBOX_USERS_BY_PROFILE, eliminado: eliminado });
    }
}

/**
 * Se ordena la tabla por una columna.
 * @param {any} columnIndex
 */
export function orderColumn(columnIndex) {
    LogHelper.In(orderColumn.name, columnIndex);
    return (dispatch, getState) => {
        dispatch({ type: FILTER_ORDER_COLUMN_USERS_BY_PROFILE, columnIndex: columnIndex });
    }
}

/**
 * Se setea el valor de todos los checkbox de la tabla.
 * @param {any} allCheckboxFilter
 * @param {any} currentUser
 */
export function setAllCheckbox(allCheckboxFilter, currentUser) {
    LogHelper.In(setAllCheckbox.name, allCheckboxFilter, currentUser);
    return (dispatch) => {
        dispatch({ type: SET_ALL_CHECKBOX_USERS_BY_PROFILE, allCheckboxFilter: allCheckboxFilter, currentUser: currentUser });
    }
}

/**
 * Setea el valor de un checkbox de la tabla.
 * @param {any} usuarioId
 */
export function setCheckbox(usuarioId) {
    LogHelper.In(setCheckbox.name, usuarioId);
    return (dispatch) => {
        dispatch({ type: FILTER_CHECKBOX_USERS_BY_PROFILE, usuarioId: usuarioId });
    }
}

/**
 * Setea el estado del usuario.
 * @param {any} id
 * @param {any} activo
 * @param {any} bloqueado
 */
export function setUserState(id, activo, bloqueado) {
    LogHelper.In(setUserState.name, id, activo, bloqueado);

    let caseActive;
    let ruleName;
    let usuariosToUpdateState = [];
    let usuariosToDeleteBlockUnblock = [];
    let localvaluesUpdateUsuarioEstado;
    let localvaluesDeleteBlockUnblockUsuario;

    return (dispatch, getState) => {
        const state = getState();

        if (activo == false) {
            if (bloqueado == false) { caseActive = 1; }
            else { caseActive = 3; }
        } else { if (bloqueado == false) { caseActive = 2; } }

        if (id == undefined || id == null) {
            if (state.usuariosPorPerfil.usuariosFiltrados != undefined) {
                state.usuariosPorPerfil.usuariosFiltrados.filter(x => x.Seleccionado == true && x.Id != state.usuariosPorPerfil.currentUser).forEach(function (item) {
                    localvaluesUpdateUsuarioEstado = {
                        "USUARIO_ID": item.Id,
                        "ACTIVO": activo
                    }

                    switch (caseActive) {
                        case 1: {
                            ruleName = "DeleteUsuario";
                            localvaluesDeleteBlockUnblockUsuario = { "USUARIO_ID": item.Id, "CURRENT_USER": state.usuariosPorPerfil.currentUser, "FECHA_ELIMINADO": null }
                            break;
                        }
                        case 2: {
                            ruleName = "UnlockUsuario";
                            localvaluesDeleteBlockUnblockUsuario = { "USUARIO_ID": item.Id }
                            break;
                        }
                        case 3: {
                            ruleName = "LockUsuario";
                            localvaluesDeleteBlockUnblockUsuario = { "USUARIO_ID": item.Id, "CURRENT_USER": state.usuariosPorPerfil.currentUser, "FECHA_BLOQUEADO": null }
                            break;
                        }
                        default: {
                            break;
                        }
                    }

                    usuariosToUpdateState.push(localvaluesUpdateUsuarioEstado);
                    usuariosToDeleteBlockUnblock.push(localvaluesDeleteBlockUnblockUsuario);
                })

                Engine1Proxy.AddRuleRequests({ UsuariosToUpdateState: usuariosToUpdateState }, "UpdateUsuarioEstado", _currentScope.ProductCode, "SEGURIDAD");
                Engine1Proxy.AddRuleRequests({ UsuariosToDeleteBlockUnblock: usuariosToDeleteBlockUnblock }, ruleName, _currentScope.ProductCode, "SEGURIDAD");
                Engine1Proxy.Execute((data) => setUserStateCallback(data, usuariosToDeleteBlockUnblock, ruleName, state.usuariosPorPerfil.usuarios), null, null, "SEGURIDAD");
            }
        } else {
            localvaluesUpdateUsuarioEstado = {
                "USUARIO_ID": id,
                "ACTIVO": activo
            }

            switch (caseActive) {
                case 1: {
                    ruleName = "DeleteUsuario";
                    localvaluesDeleteBlockUnblockUsuario = { "USUARIO_ID": id, "CURRENT_USER": state.usuariosPorPerfil.currentUser, "FECHA_ELIMINADO": null }
                    break;
                }
                case 2: {
                    ruleName = "UnlockUsuario";
                    localvaluesDeleteBlockUnblockUsuario = { "USUARIO_ID": id }
                    break;
                }
                case 3: {
                    ruleName = "LockUsuario";
                    localvaluesDeleteBlockUnblockUsuario = { "USUARIO_ID": id, "CURRENT_USER": state.usuariosPorPerfil.currentUser, "FECHA_BLOQUEADO": null }
                    break;
                }
                default: {
                    break;
                }
            }

            let tempList = [];
            tempList.push(localvaluesDeleteBlockUnblockUsuario);

            Engine1Proxy.AddRuleRequests(localvaluesUpdateUsuarioEstado, "UpdateUsuarioEstado", _currentScope.ProductCode, "SEGURIDAD");
            Engine1Proxy.AddRuleRequests(localvaluesDeleteBlockUnblockUsuario, ruleName, _currentScope.ProductCode, "SEGURIDAD");
            Engine1Proxy.Execute((data) => setUserStateCallback(data, tempList, ruleName, state.usuariosPorPerfil.usuarios), null, null, "SEGURIDAD");
        }
    }
}


/**
 * Setea el motivo de bloqueo del o los usuario seleccionados.
 * @param {any} motivoBloqueo
 */
export function setMotivoBloqueo(motivoBloqueo) {
    LogHelper.In(setMotivoBloqueo.name, motivoBloqueo);

    return (dispatch, getState) => {
        const state = getState();

        let usuariosToEdit = [];

        if (state.usuariosPorPerfil.usuariosFiltrados != undefined) {
            state.usuariosPorPerfil.usuariosFiltrados.filter(x => x.Bloqueado == true).forEach(function (item) {
                let localvalues = {
                    'USUARIO_ID': item.Id,
                    'MOTIVO_BLOQUEO': motivoBloqueo,
                }

                usuariosToEdit.push(localvalues);
            })
        }

        if (usuariosToEdit.length > 0) {
            LogHelper.Out(setMotivoBloqueo.name, { UsuariosToEdit: usuariosToEdit }, "UpdateUsuarioMotivoBloqueo", _currentScope.ProductCode, "SEGURIDAD");
            Engine1Proxy.AddRuleRequests({ UsuariosToEdit: usuariosToEdit }, "UpdateUsuarioMotivoBloqueo", _currentScope.ProductCode, "SEGURIDAD");
            Engine1Proxy.Execute(setMotivoBloqueoCallback, null, null, "SEGURIDAD");
        }
    }
}

/**--------------------------- FUNCIONES AUXILIARES ----------------------------**/

/**
 * Funcion callback de la obtencion de las funciones del usuario.
 * @param {any} data
 */
function getFunctionsCallback(data) {
    LogHelper.In(getFunctionsCallback.name, data);

    let functions = data.SEGURIDAD;
    functions.forEach(p => { functions[p.Codigo_Funcion] = true; });

    _dispatch({ type: SET_FUNCTIONS_USERS_BY_PROFILE, functions });

    let paramProfile = {
        'PERFIL_ID': _profileId
    }

    if (functions.Consulta == true) {
        Engine1Proxy.AddDataSourcesRequests(paramProfile, 'GET_PERFIL_BY_ID', 'Get', _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramProfile, 'GET_USERS_BY_PROFILE', 'Get', _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
        Engine1Proxy.Execute(getDataCallback, null, null, "SEGURIDAD");
    }
}

/**
 * Funcion callback de la obtencion de los datos principales para popular la pantalla.
 * @param {any} data
 */
function getDataCallback(data) {
    LogHelper.In(getDataCallback.name, data);

    let result = null;

    if (JSON.parse(data.GET_USERS_BY_PROFILE).Recordset0.Rows != undefined)
        result = JSON.parse(data.GET_USERS_BY_PROFILE).Recordset0.Rows;

    if (!_title2 && JSON.parse(data.GET_PERFIL_BY_ID).Recordset0.Rows != undefined) {
        _title2 = JSON.parse(data.GET_PERFIL_BY_ID).Recordset0.Rows;
        _dispatch({ type: SET_TITLE_USERS_BY_PROFILE, _title2 });
    }

    _dispatch({ type: GET_DATA_USERS_BY_PROFILE_SUCCESS, result });
}

/**
 * Funcion callback del cambio de estado de un usuario.
 * @param {any} data
 */
function setUserStateCallback(data, userListSelected, ruleName, userList) {
    LogHelper.In(setUserStateCallback.name, data);

    let paramProfile = {
        'PERFIL_ID': _profileId
    }

    LogUserState(userListSelected, ruleName, userList);

    Engine1Proxy.AddDataSourcesRequests(paramProfile, 'GET_USERS_BY_PROFILE', 'Get', _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
    Engine1Proxy.Execute(getDataCallback, null, null, "SEGURIDAD");
}

/**
 * Funcion callback del desbloqueo de un usuario.
 * @param {any} data
 */
function setMotivoBloqueoCallback(data) {
    LogHelper.In(setUserStateCallback.name, data);

    let paramProfile = {
        'PERFIL_ID': _profileId
    }

    Engine1Proxy.AddDataSourcesRequests(paramProfile, 'GET_USERS_BY_PROFILE', 'Get', _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
    Engine1Proxy.Execute(getDataCallback, null, null, "SEGURIDAD");
}



function LogUserState(userListSelected, ruleName, userList) {

    let action = null;
    let tags = null;

    userListSelected.forEach(function (user) {

        let userData = userList.filter(x => x.Id == user.USUARIO_ID);

        switch (ruleName) {

            case "DeleteUsuario":
                tags = "SEGURIDAD,BAJA,USUARIO";
                action = "Eliminación del Usuario " + userData[0].Login + " - " + userData[0].Nombre + " ; de la Sucursal: " + userData[0].SUCURSAL + " " + " ; del Sector:  " + userData[0].SECTOR;
                break;

            case "UnlockUsuario":

                if (userData[0].FechaEliminado) {
                    tags = "SEGURIDAD,REACTIVACION,USUARIO";
                    action = "Reactivación del Usuario " + userData[0].Login + " - " + userData[0].Nombre + " ; de la Sucursal: " + userData[0].SUCURSAL + " " + " ; del Sector:  " + userData[0].SECTOR;
                } else {
                    tags = "SEGURIDAD,DESBLOQUEO,USUARIO";
                    action = "Desbloqueo del Usuario " + userData[0].Login + " - " + userData[0].Nombre + " ; de la Sucursal: " + userData[0].SUCURSAL + " " + " ; del Sector:  " + userData[0].SECTOR;
                }

                break;

            case "LockUsuario":
                tags = "SEGURIDAD,BLOQUEO,USUARIO";
                action = "Bloqueo del Usuario " + userData[0].Login + " - " + userData[0].Nombre + " ; de la Sucursal: " + userData[0].SUCURSAL + " " + " ; del Sector:  " + userData[0].SECTOR;
                break;
        }

        LogsProxy.SaveOperationLog(tags, action, null, null, null, null, null, "SEGURIDAD");

    })
}